import { Calendar } from "primereact/calendar";
import React, { useEffect, useState } from "react";
import './SolicitudesReclutamiento.scss'
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getSolicitudesReclutamiento, verificar } from "./integracion";
import { formateoBasico } from "../../../utilidades/formateos";
const SolicitudesReclutamiento = () => {
    const [filtros, setFiltros] = useState({
        fecha_inicio: new Date(),
        fecha_fin: new Date()
    })
    const [data, setData] = useState([])
    useEffect(() => {
        const result = getSolicitudesReclutamiento( formateoBasico(filtros.fecha_inicio), formateoBasico(filtros.fecha_fin))
            .then((value) => {
                setData(value);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })

    }, [filtros])
    //     CREATE TABLE TH_SOLICITUD_RECLUTAMIENTO (
    //     ID INT IDENTITY(1,1) PRIMARY KEY,
    //     FECHA DATETIME NOT NULL DEFAULT GETDATE(),
    //     NOMBRE NVARCHAR(300)  NULL,
    //     TELEFONO NVARCHAR(20)  NULL,
    //     CALLE NVARCHAR(MAX)  NULL,
    //     COLONIA NVARCHAR(MAX)  NULL,
    //     CODIGO_POSTAL NVARCHAR(10)  NULL,
    //     EXPERIENCIA BIT NOT NULL DEFAULT 0,
    //     TIEMPO_EXPERIENCIA NVARCHAR(MAX) NULL,
    //     TIPO_LICENCIA NVARCHAR(20) NULL,
    //     VERIFICADO BIT NOT NULL DEFAULT 0
    // );

    const experiencia = (rowData) => {
        return rowData.EXPERIENCIA ? "✅" : "⛔";
    }
    const verificado = (rowData) => {
        return rowData.VERIFICADO ? <div style={{cursor:"pointer"}} onClick={()=>{verificarEstado(rowData.ID, false)}}>✅</div> : <div style={{cursor:"pointer"}} onClick={()=>verificarEstado(rowData.ID, true)}>⛔</div>;
    }
    const verificarEstado = async (id, estado) => {
        await verificar(id, estado)
            .then(() => {
                setData((prevData) =>
                    prevData.map((item) =>
                        item.ID === id ? { ...item, VERIFICADO: estado } : item
                    )
                );
            })
            .catch((error) => {
                console.error("Error updating verification:", error);
            });
    };
    return (
        <div className="SolicitudesReclutamiento">
            <div className="filtros">

                <Calendar dateFormat="dd/mm/yy" placeholder="fecha_inicio" showIcon value={filtros.fecha_inicio} onChange={(e) => setFiltros({ ...filtros, fecha_inicio: e.value })}></Calendar>
                <Calendar dateFormat="dd/mm/yy" placeholder="fecha_fin" showIcon value={filtros.fecha_fin} onChange={(e) => setFiltros({ ...filtros, fecha_fin: e.value })}></Calendar>
            </div>
            <div className="contenido-solicitudes">
                <DataTable value={data} responsiveLayout="scroll" className="tabla-solicitudes">
                    <Column field="ID" header="ID"></Column>
                    <Column field="FECHA" header="Fecha"></Column>
                    <Column field="NOMBRE" header="Nombre"></Column>
                    <Column field="TELEFONO" header="Telefono"></Column>
                    <Column field="CALLE" header="Calle"></Column>
                    <Column field="COLONIA" header="Colonia"></Column>
                    <Column field="CODIGO_POSTAL" header="Codigo Postal"></Column>
                    <Column field="EXPERIENCIA" header="Experiencia" body={experiencia}></Column>
                    <Column field="TIEMPO_EXPERIENCIA" header="Tiempo Experiencia"></Column>
                    <Column field="TIPO_LICENCIA" header="Tipo Licencia"></Column>
                    <Column field="VERIFICADO" header="Verificado" body={verificado}></Column>
                </DataTable>
            </div>
        </div>
    );
}
export default SolicitudesReclutamiento;